var _mask, _g, _mask2, _g2, _mask3, _g3, _mask4, _g4, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _circle, _path51;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIstarred(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 377,
    height: 377,
    viewBox: "0 0 377 377",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 57,
    y: 136,
    width: 133,
    height: 77
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.5 136.5H188.534V211.552H57.5V136.5Z",
    fill: "white",
    stroke: "#00C2A8"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57 211.365L189.034 135.313",
    stroke: "#00C2A8",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8518 212.727L189.034 142.918",
    stroke: "#00C2A8",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57 203.76L175.832 135.313",
    stroke: "#00C2A8",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.0542 212.727L189.034 150.524",
    stroke: "#00C2A8",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57 196.155L162.629 135.313",
    stroke: "#00C2A8",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2566 212.728L189.034 158.129",
    stroke: "#00C2A8",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57 188.55L149.427 135.313",
    stroke: "#00C2A8",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.459 212.728L189.034 165.734",
    stroke: "#00C2A8",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57 180.944L136.225 135.313",
    stroke: "#00C2A8",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.672 212.727L189.034 173.339",
    stroke: "#00C2A8",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57 173.339L123.022 135.313",
    stroke: "#00C2A8",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.874 212.728L189.034 180.944",
    stroke: "#00C2A8",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57 165.734L109.82 135.313",
    stroke: "#00C2A8",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.077 212.727L189.034 188.549",
    stroke: "#00C2A8",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57 158.129L96.6176 135.313",
    stroke: "#00C2A8",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.279 212.728L189.034 196.155",
    stroke: "#00C2A8",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57 150.524L83.4153 135.313",
    stroke: "#00C2A8",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.481 212.728L189.034 203.76",
    stroke: "#00C2A8",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.683 212.728L189.034 211.365",
    stroke: "#00C2A8",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57 142.919L70.2023 135.313",
    stroke: "#00C2A8",
    strokeLinecap: "square"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 57,
    y: 211,
    width: 133,
    height: 77
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.5 212.419H188.534V287.471H57.5V212.419Z",
    fill: "white",
    stroke: "#00C2A8"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57 287.284L189.034 211.233",
    stroke: "#00C2A8",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8518 288.647L189.034 218.838",
    stroke: "#00C2A8",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57 279.679L175.832 211.233",
    stroke: "#00C2A8",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.0542 288.647L189.034 226.443",
    stroke: "#00C2A8",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57 272.074L162.629 211.233",
    stroke: "#00C2A8",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2566 288.647L189.034 234.048",
    stroke: "#00C2A8",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57 264.469L149.427 211.233",
    stroke: "#00C2A8",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.459 288.647L189.034 241.654",
    stroke: "#00C2A8",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57 256.864L136.225 211.233",
    stroke: "#00C2A8",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.672 288.647L189.034 249.259",
    stroke: "#00C2A8",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57 249.259L123.022 211.233",
    stroke: "#00C2A8",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.874 288.647L189.034 256.864",
    stroke: "#00C2A8",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57 241.654L109.82 211.233",
    stroke: "#00C2A8",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.077 288.647L189.034 264.469",
    stroke: "#00C2A8",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57 234.048L96.6176 211.233",
    stroke: "#00C2A8",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.279 288.647L189.034 272.074",
    stroke: "#00C2A8",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57 226.443L83.4153 211.233",
    stroke: "#00C2A8",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.481 288.647L189.034 279.679",
    stroke: "#00C2A8",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.683 288.647L189.034 287.284",
    stroke: "#00C2A8",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57 218.838L70.2023 211.233",
    stroke: "#00C2A8",
    strokeLinecap: "square"
  }))), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "mask2",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 189,
    y: 136,
    width: 133,
    height: 77
  }, /*#__PURE__*/React.createElement("path", {
    d: "M189.534 136.5H320.568V211.552H189.534V136.5Z",
    fill: "white",
    stroke: "#00C2A8"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M189.034 211.365L321.068 135.313",
    stroke: "#00C2A8",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.886 212.727L321.068 142.918",
    stroke: "#00C2A8",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.034 203.76L307.866 135.313",
    stroke: "#00C2A8",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.088 212.727L321.068 150.524",
    stroke: "#00C2A8",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.034 196.155L294.663 135.313",
    stroke: "#00C2A8",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.291 212.728L321.068 158.129",
    stroke: "#00C2A8",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.034 188.55L281.461 135.313",
    stroke: "#00C2A8",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.493 212.728L321.068 165.734",
    stroke: "#00C2A8",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.034 180.944L268.259 135.313",
    stroke: "#00C2A8",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.706 212.727L321.068 173.339",
    stroke: "#00C2A8",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.034 173.339L255.056 135.313",
    stroke: "#00C2A8",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.908 212.728L321.068 180.944",
    stroke: "#00C2A8",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.034 165.734L241.854 135.313",
    stroke: "#00C2A8",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.11 212.727L321.068 188.549",
    stroke: "#00C2A8",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.034 158.129L228.652 135.313",
    stroke: "#00C2A8",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.313 212.728L321.068 196.155",
    stroke: "#00C2A8",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.034 150.524L215.449 135.313",
    stroke: "#00C2A8",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.515 212.728L321.068 203.76",
    stroke: "#00C2A8",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.717 212.728L321.068 211.365",
    stroke: "#00C2A8",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.034 142.919L202.236 135.313",
    stroke: "#00C2A8",
    strokeLinecap: "square"
  }))), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "mask3",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 189,
    y: 211,
    width: 133,
    height: 77
  }, /*#__PURE__*/React.createElement("path", {
    d: "M189.534 212.419H320.568V287.471H189.534V212.419Z",
    fill: "white",
    stroke: "#00C2A8"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M189.034 287.284L321.068 211.233",
    stroke: "#00C2A8",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.886 288.647L321.068 218.838",
    stroke: "#00C2A8",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.034 279.679L307.866 211.233",
    stroke: "#00C2A8",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.088 288.647L321.068 226.443",
    stroke: "#00C2A8",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.034 272.074L294.663 211.233",
    stroke: "#00C2A8",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.291 288.647L321.068 234.048",
    stroke: "#00C2A8",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.034 264.469L281.461 211.233",
    stroke: "#00C2A8",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.493 288.647L321.068 241.654",
    stroke: "#00C2A8",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.034 256.864L268.259 211.233",
    stroke: "#00C2A8",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.706 288.647L321.068 249.259",
    stroke: "#00C2A8",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.034 249.259L255.056 211.233",
    stroke: "#00C2A8",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.908 288.647L321.068 256.864",
    stroke: "#00C2A8",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.034 241.654L241.854 211.233",
    stroke: "#00C2A8",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.11 288.647L321.068 264.469",
    stroke: "#00C2A8",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.034 234.048L228.652 211.233",
    stroke: "#00C2A8",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.313 288.647L321.068 272.074",
    stroke: "#00C2A8",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.034 226.443L215.449 211.233",
    stroke: "#00C2A8",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.515 288.647L321.068 279.679",
    stroke: "#00C2A8",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.717 288.647L321.068 287.284",
    stroke: "#00C2A8",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.034 218.838L202.236 211.233",
    stroke: "#00C2A8",
    strokeLinecap: "square"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M211.053 271.298H95.0228C92.8521 271.298 91.1008 269.547 91.1008 267.377V110.258C91.1008 108.088 92.8521 106.337 95.0228 106.337H211.078C213.249 106.337 215 108.088 215 110.258V267.377C215 269.547 213.224 271.298 211.053 271.298Z",
    fill: "white",
    stroke: "#1071E5",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M205.37 264.478H89.3392C87.1685 264.478 85.4172 262.727 85.4172 260.557V103.438C85.4172 101.268 87.1685 99.5167 89.3392 99.5167H205.395C207.565 99.5167 209.317 101.268 209.317 103.438V260.557C209.317 262.727 207.541 264.478 205.37 264.478Z",
    fill: "white",
    stroke: "#1071E5",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M198.55 257.019H82.5191C80.3485 257.019 78.5972 255.268 78.5972 253.098V95.9788C78.5972 93.8086 80.3485 92.0576 82.5191 92.0576H198.574C200.745 92.0576 202.496 93.8086 202.496 95.9788V253.098C202.496 255.268 200.72 257.019 198.55 257.019Z",
    fill: "white",
    stroke: "#1071E5",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M188.831 109H92.2625V116.867H188.831V109Z",
    fill: "#FCCE14"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M126.542 221.391V187.112H92.2552V221.391H126.542Z",
    fill: "#FCCE14"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M164.781 121.257H115.621V124.34H164.781V121.257Z",
    fill: "#FCCE14"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M188.831 139.63H105.483V142.861H188.831V139.63Z",
    fill: "#F2F3F5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M133.455 144.858H92.2625V148.089H133.455V144.858Z",
    fill: "#F2F3F5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M140.535 155.29H92.2625V158.521H140.535V155.29Z",
    fill: "#F2F3F5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M166.903 144.858H137.723V148.089H166.903V144.858Z",
    fill: "#F2F3F5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M188.806 144.858H170.134V148.089H188.806V144.858Z",
    fill: "#F2F3F5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M188.807 150.086H179.976V153.317H188.807V150.086Z",
    fill: "#F2F3F5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M101.093 139.63H92.2625V142.86H101.093V139.63Z",
    fill: "#F2F3F5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M188.807 155.29H168.161V158.521H188.807V155.29Z",
    fill: "#F2F3F5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M176.424 150.086H116.953V153.317H176.424V150.086Z",
    fill: "#F2F3F5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M112.094 150.086H92.2625V153.317H112.094V150.086Z",
    fill: "#F2F3F5"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M164.436 155.29H144.604V158.521H164.436V155.29Z",
    fill: "#F2F3F5"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2406 164.446L175.588 164.446L175.588 161.215L92.2406 161.215L92.2406 164.446Z",
    fill: "#F2F3F5"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M147.613 169.661L188.806 169.661L188.806 166.431L147.613 166.431L147.613 169.661Z",
    fill: "#F2F3F5"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M140.545 180.117L188.817 180.117L188.817 176.886L140.545 176.886L140.545 180.117Z",
    fill: "#F2F3F5"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M114.174 169.661L143.354 169.661L143.354 166.431L114.174 166.431L114.174 169.661Z",
    fill: "#F2F3F5"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2484 169.661L110.921 169.661L110.921 166.431L92.2484 166.431L92.2484 169.661Z",
    fill: "#F2F3F5"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2551 174.901L101.086 174.901L101.086 171.671L92.2551 171.671L92.2551 174.901Z",
    fill: "#F2F3F5"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M179.985 164.446L188.816 164.446L188.816 161.215L179.985 161.215L179.985 164.446Z",
    fill: "#F2F3F5"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2527 180.117L112.898 180.117L112.898 176.886L92.2527 176.886L92.2527 180.117Z",
    fill: "#F2F3F5"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M104.637 174.901L164.108 174.901L164.108 171.671L104.637 171.671L104.637 174.901Z",
    fill: "#F2F3F5"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M168.988 174.901L188.82 174.901L188.82 171.671L168.988 171.671L168.988 174.901Z",
    fill: "#F2F3F5"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M116.62 180.117L136.451 180.117L136.451 176.886L116.62 176.886L116.62 180.117Z",
    fill: "#F2F3F5"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2406 231.23L175.588 231.23L175.588 227.999L92.2406 227.999L92.2406 231.23Z",
    fill: "#F2F3F5"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M147.613 236.47L188.806 236.47L188.806 233.239L147.613 233.239L147.613 236.47Z",
    fill: "#F2F3F5"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M140.545 246.901L188.817 246.901L188.817 243.67L140.545 243.67L140.545 246.901Z",
    fill: "#F2F3F5"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M114.174 236.47L143.354 236.47L143.354 233.239L114.174 233.239L114.174 236.47Z",
    fill: "#F2F3F5"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2484 236.47L110.921 236.47L110.921 233.239L92.2484 233.239L92.2484 236.47Z",
    fill: "#F2F3F5"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2551 241.685L101.086 241.685L101.086 238.455L92.2551 238.455L92.2551 241.685Z",
    fill: "#F2F3F5"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M179.985 231.23L188.816 231.23L188.816 227.999L179.985 227.999L179.985 231.23Z",
    fill: "#F2F3F5"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2527 246.901L112.898 246.901L112.898 243.67L92.2527 243.67L92.2527 246.901Z",
    fill: "#F2F3F5"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M104.637 241.685L164.108 241.685L164.108 238.455L104.637 238.455L104.637 241.685Z",
    fill: "#F2F3F5"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M168.988 241.685L188.82 241.685L188.82 238.455L168.988 238.455L168.988 241.685Z",
    fill: "#F2F3F5"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M116.62 246.901L136.451 246.901L136.451 243.67L116.62 243.67L116.62 246.901Z",
    fill: "#F2F3F5"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M180.445 195.907H137.377V198.004H180.445V195.907Z",
    fill: "#1071E5"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M134.047 198.102C134.674 198.102 135.182 197.594 135.182 196.968C135.182 196.341 134.674 195.833 134.047 195.833C133.421 195.833 132.913 196.341 132.913 196.968C132.913 197.594 133.421 198.102 134.047 198.102Z",
    fill: "#1071E5"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M173.908 201.062H137.377V203.158H173.908V201.062Z",
    fill: "#1071E5"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M134.047 203.257C134.674 203.257 135.182 202.749 135.182 202.122C135.182 201.496 134.674 200.988 134.047 200.988C133.421 200.988 132.913 201.496 132.913 202.122C132.913 202.749 133.421 203.257 134.047 203.257Z",
    fill: "#1071E5"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M169.468 206.241H137.377V208.337H169.468V206.241Z",
    fill: "#1071E5"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M134.047 208.411C134.674 208.411 135.182 207.903 135.182 207.277C135.182 206.65 134.674 206.142 134.047 206.142C133.421 206.142 132.913 206.65 132.913 207.277C132.913 207.903 133.421 208.411 134.047 208.411Z",
    fill: "#1071E5"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M177.164 211.395H137.377V213.491H177.164V211.395Z",
    fill: "#1071E5"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M134.047 213.565C134.674 213.565 135.182 213.057 135.182 212.431C135.182 211.804 134.674 211.296 134.047 211.296C133.421 211.296 132.913 211.804 132.913 212.431C132.913 213.057 133.421 213.565 134.047 213.565Z",
    fill: "#1071E5"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M129.73 131.368H151.338",
    stroke: "#1071E5",
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M129.73 102.169H151.338",
    stroke: "#1071E5",
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M188.807 187.103V221.383",
    stroke: "#1071E5",
    strokeMiterlimit: 10
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 205.848,
    cy: 91.6743,
    r: 24.3483,
    fill: "#FCCE14",
    stroke: "white",
    strokeWidth: 3
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M205.848 76.2363L209.314 86.9037H220.531L211.456 93.4966L214.922 104.164L205.848 97.5711L196.774 104.164L200.24 93.4966L191.166 86.9037H202.382L205.848 76.2363Z",
    fill: "#680094"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIstarred);
export default __webpack_public_path__ + "static/media/istarred.2b693fe07d5fa8f4a7bcb0541fe287a1.svg";
export { ForwardRef as ReactComponent };